import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from  '@angular/common/http';
import { environment } from '../../../environments/environment';
import {Router} from "@angular/router";
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ApiparserService {
  constructor(
    private  httpClient:  HttpClient, private Router: Router
  ) { }


  hit(url, method, data, needRaw=false, headers=false){
    url = environment.proxy + url;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    };
    if(method == 'get' || method =='delete'){
      data.headers = new HttpHeaders({
        'Content-Type':  'application/json',
      });
      if(headers) data.observe = 'response';
    }
    return this.parse(
      this.httpClient[method](url, data, httpOptions).pipe(
        timeout(60000)
      ), needRaw, headers
    );
  }

  private parse(reqPromise, needRaw, headers){
    return new Promise((resolve, reject)=>{
      reqPromise.subscribe(function(res){
        if(headers){
           let pagination = {
            count: res.headers.get('x-pagination-count'),
            limit: res.headers.get('x-pagination-limit'),
            offset: res.headers.get('x-pagination-offset'),
            unread: res.headers.get('x-unread-count')
          };
          return resolve({
            data: res.body,
            pagination: pagination
          });
        }

        if(needRaw) return resolve(res);
        let response = res ? (res.data || res) : res;
        resolve(response);
      }, (res)=>{
        if(res && res.status === 401){
          this.Router.navigate(['/']);
        }
        reject(res.error);
      });
    });
  }
}
